module.exports = __webpack_public_path__ + "static/media/i-will-tell-you-album-cover.a3fb29d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/routes/music/i-will-tell-you/i-will-tell-you-album-cover.jpg
// module id = 21
// module chunks = 0